
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { X, Check } from 'lucide-react';

interface ManualEntryFormProps {
  manualEmail: string;
  onEmailChange: (email: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
}

const ManualEntryForm: React.FC<ManualEntryFormProps> = ({
  manualEmail,
  onEmailChange,
  onCancel,
  onSubmit
}) => {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="email">Email Address</Label>
        <Input
          id="email"
          type="email"
          placeholder="friend@example.com"
          value={manualEmail}
          onChange={(e) => onEmailChange(e.target.value)}
        />
      </div>
      
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          className="w-full"
          onClick={onCancel}
        >
          <X className="h-4 w-4 mr-2" /> Cancel
        </Button>
        <Button 
          className="w-full bg-givgo-purple hover:bg-givgo-purple/90"
          onClick={onSubmit}
          disabled={!manualEmail || !manualEmail.includes('@')}
        >
          <Check className="h-4 w-4 mr-2" /> Confirm
        </Button>
      </div>
    </div>
  );
};

export default ManualEntryForm;
